import { render, staticRenderFns } from "./SideBarBilling.vue?vue&type=template&id=38b227c6"
import script from "./SideBarBilling.vue?vue&type=script&lang=js"
export * from "./SideBarBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports